import { db } from '../firebase/config';
import { collection, getDocs, doc, getDoc, query, orderBy, where } from 'firebase/firestore';

export const getEvents = async () => {
    const q = query(collection(db, 'events'), orderBy('order', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getLatestEvents = async (count = 3) => {
    const events = await getEvents();
    return events.slice(0, count);
};

export const getEventById = async (id) => {
    const docRef = doc(db, 'events', id);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
};

// --- Announcements ---
export const getAnnouncements = async () => {
    const q = query(collection(db, 'announcements'), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getLatestAnnouncements = async (count = 5) => {
    const all = await getAnnouncements();
    return all.slice(0, count);
};

export const getAnnouncementById = async (id) => {
    const docRef = doc(db, 'announcements', id);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
};

// --- Team ---
export const getTeamMembers = async (category) => {
    let q;
    if (category) {
        q = query(collection(db, 'team'), where('category', '==', category));
    } else {
        q = collection(db, 'team');
    }
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

// --- Blogs ---
export const getBlogs = async () => {
    const q = query(collection(db, 'blogs'), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getBlogById = async (id) => {
    const docRef = doc(db, 'blogs', id);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
};

// --- Magazines ---
export const getMagazines = async () => {
    const q = query(collection(db, 'magazines'), orderBy('date', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};
